import { AlertDescriptionProps as ChakraAlertDescriptionProps } from '@chakra-ui/react-v2';
import { chakra, forwardRef } from '@chakra-ui/system';
import { cx } from '@chakra-ui/utils';

import { useAlertContext, useAlertStyles } from './utils/AlertContext';

export type AlertDescriptionProps = ChakraAlertDescriptionProps;

export const AlertDescription = forwardRef<AlertDescriptionProps, 'div'>(
  function AlertDescription(props, ref) {
    const { status } = useAlertContext();

    const styles = useAlertStyles();

    return (
      <chakra.div
        ref={ref}
        data-status={status}
        {...props}
        className={cx('chakra-alert__desc', props.className)}
        __css={styles.description}
      />
    );
  },
);

AlertDescription.displayName = 'AlertDescription';
